/**
 * Plan tier identifiers — values match the backend PlanTier enum exactly.
 * Use these constants instead of raw strings throughout the frontend.
 */
export const PlanTier = Object.freeze({
  FREE: 'FREE',
  STANDARD: 'STANDARD',
  PREMIUM: 'PREMIUM',
  ENTERPRISE: 'ENTERPRISE',
});

/**
 * Feature type identifiers — values match the backend FeatureType enum exactly.
 * BOOLEAN  : on/off flag (e.g. COPY_PAST_JD, POST_TO_LINKEDIN)
 * NUMERIC  : numeric limit (e.g. MAX_PROJECTS, MAX_ACTIVE_USERS)
 * ENUM     : set of allowed values (e.g. MEETING_PLATFORMS, INTERVIEW_PANEL_MODE)
 */
export const FeatureType = Object.freeze({
  BOOLEAN: 'BOOLEAN',
  NUMERIC: 'NUMERIC',
  ENUM: 'ENUM',
});

